import Head from 'next/head'
import * as React from 'react'
import { JsonLd } from 'react-schemaorg'
import { Product as SchemaProduct } from 'schema-dts'

import { CollectionLayoutFragmentFragment } from '../../../__generated__/graphql/catalog/graphql'
import { canonicalBaseUrls, imageSrcs } from '../../../constants/figs'

export const SchemaTags: React.FC<{
  collectionView?: Pick<
    CollectionLayoutFragmentFragment,
    'handle' | 'name' | 'id' | 'socialDescription' | 'socialImage' | 'sections'
  >
}> = ({ collectionView }) => {
  const { handle, name, socialDescription, socialImage, sections } = collectionView || {}
  const pageUrl = canonicalBaseUrls.collections + handle
  const imageUrl = socialImage?.replace(/^\/\//, 'https://')
  const selectedGender =
    sections
      ?.map(section => {
        if (section.__typename === 'GenderNavSection') {
          return section.selectedGender
        } else {
          return null
        }
      })
      .find(genderString => !!genderString) ?? 'Unisex'

  return (
    <Head>
      <JsonLd<SchemaProduct>
        item={{
          '@context': 'https://schema.org',
          '@id': pageUrl,
          '@type': 'ProductCollection',
          'url': pageUrl,
          'brand': {
            '@type': 'Brand',
            'name': 'FIGS',
            'logo': {
              '@type': 'ImageObject',
              'name': 'FIGS Logo',
              'contentUrl': imageSrcs.metaImage,
            },
            'slogan': 'Why wear scrubs, when you can wear FIGS?',
          },
          'name': name,
          'description': socialDescription || '',
          'image': imageUrl,
          'manufacturer': {
            '@type': 'Organization',
            'name': 'FIGS INC.',
            'url': 'https://www.wearfigs.com',
          },
          'audience': {
            '@type': 'PeopleAudience',
            'suggestedGender': selectedGender,
          },
        }}
      />
    </Head>
  )
}
